/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoAssignRole } from '../../models/dto-assign-role';
import { OptionalRefreshTokenResponse } from '../../models/optional-refresh-token-response';

export interface IdentityControllerAssignRole$Params {
      body: DtoAssignRole
}

export function identityControllerAssignRole(http: HttpClient, rootUrl: string, params: IdentityControllerAssignRole$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OptionalRefreshTokenResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerAssignRole.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OptionalRefreshTokenResponse;
      }>;
    })
  );
}

identityControllerAssignRole.PATH = '/identity/role';
